import { render } from "./RewardModal.vue?vue&type=template&id=08c745be"
import script from "./RewardModal.vue?vue&type=script&lang=js"
export * from "./RewardModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__